import React from 'react';
import { CurricularClass92023 } from 'views/CurricularClass52023/components';

const ExtraCurricularActivitiesPage = () => {
  return <CurricularClass92023 />;
};

export default ExtraCurricularActivitiesPage;
